// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"424": "372fb92a9cdaa0df","757": "0d98c092d6b54a27",}[chunkId] + ".css"
}